export const RESET = 'EXCMCASEPROBLEM_UPDATE_RESET'
export const SET_ERROR = 'EXCMCASEPROBLEM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCASEPROBLEM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCASEPROBLEM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCASEPROBLEM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCASEPROBLEM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCASEPROBLEM_UPDATE_UPDATE_RETRIEVED'
